/* global moment */
import { Api } from '@/core/api.js'
import Vue from 'vue'

const api = new Api()

// initial state
const state = {
  user: {},
  exp: -1,
  login: null,
  userLoadStatus: 0,
  userIsBackOffice: false
}

// getters
const getters = {
  getSession (state) {
    return { user: state.user, exp: state.exp, login: state.login }
  },
  /*
        Returns the user load status.
    */
  getUserLoadStatus (state) {
    return function () {
      return state.userLoadStatus
    }
  },

  getUser (state) {
    return state.user
  },

  getUserIsBackOffice (state) {
    return state.userIsBackOffice
  }
}

const actions = {
  loadUser: ({ dispatch, commit, rootState }) => {
    return api.get('init').then(function (response) {
      dispatch('loadEventByID', response.data.user.event_id).then(function () {
        return commit('setAuthenticate', response.data)
      })
    })
  },

  loginClub: ({ dispatch, commit, rootState }, params) => {
    params.username = state.user.username
    params.password = state.user.password

    return api.post('login?nocache=' + new Date().getTime(), params).then(function (response) {
      return response
    })
  }
}
const mutations = {
  setAuthenticate (state, data) {
    if (!data) {
      state = {
        user: {},
        exp: -1,
        login: null,
        userLoadStatus: 0
      }

      localStorage.removeItem('token')
    } else {
      data.user.avatar = '/img/avatar.jpg'
      state.user = data.user
      state.user.letter = data.user.name.substring(0, 1).toUpperCase()
      state.exp = data.exp
      state.login = moment()
      state.userLoadStatus = 2
      state.user.token = data.token
      if (data.origin && data.origin.controller && data.origin.controller === 'Login') {
        state.userIsBackOffice = true
      }
      // check if isset user and teams
      if (data.user && !data.user.admin && data.user.teams) {
        // check if active team is isset in localstorage
        // if(!localStorage.getItem("team_id")){
        // save first item
        localStorage.setItem('team_id', Object.keys(data.user.teams)[0])
        // }
        // set team_id
        state.user.team_id = localStorage.getItem('team_id')
      }
    }
    return true
  },

  setAuthenticateSelClub (state, data) {
    if (!data) {
      state = {
        user: {},
        exp: -1,
        login: null,
        userLoadStatus: 0
      }
    } else {
      data.user.avatar = '/img/avatar.jpg'
      state.user = data.user
      state.user.letter = data.user.name.substring(0, 1).toUpperCase()
      state.exp = data.exp
      state.login = moment()
      state.userLoadStatus = 2
      state.user.clubs = data.clubs
      // check if isset user and teams
    }
    return true
  },

  logoutUser (state) {
    state = {
      user: {},
      exp: -1,
      login: null,
      userLoadStatus: 0
    }

    localStorage.removeItem('token')
  },

  setLanguage (state, value) {
    state.user.language = value
  },

  setTeamID (state, teamId) {
    // set item
    localStorage.setItem('team_id', teamId)
    // get team id
    state.user.team_id = localStorage.getItem('team_id')
    // set team id
    Vue.set(state, 'user', { ...state.user })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
